import React from 'react';
import PropTypes from 'prop-types';
import { quoteFormSelector, experimentIdSelector } from 'ctm-selectors';
import { Checkbox, withRules } from 'ctm-components';
import { connect } from 'react-redux';
import { pageContext, replaceBaseUrl } from 'ctm-util-functions';

/**
 * This is opt-in privacy component
 * @desc - a checkbox with opt-in text and opening hours modal button with opt-in text
 * @param {Object} props Component props
 * @return {Node} Slide Component
 */
const _OptinEmail = ({ dispatch, isToyPromoOn, isToyPromoOff, value }) => {
    const renderPromoTAndCLink = () => {
        const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
        const toyPromoTAndC = replaceBaseUrl('/evt/assets/pdf/meerkat-toys-promotion-terms-and-conditions.pdf', baseAssetsPath);

        if (isToyPromoOn && !isToyPromoOff) {
        // eslint-disable-next-line react/jsx-no-target-blank
            return  <a href={toyPromoTAndC} target="_blank" data-id="toyPromotionTAndCLink">Promotion Terms & Conditions, </a>;
        }
        return '';
    };

    const renderLabel = () => {
        return (
            <>
                {'I have read and accept Compare the Market\'s '}
                {renderPromoTAndCLink()}
                <a
                    href="https://secure.comparethemarket.com.au/static/legal/FSG.pdf"
                    target="_blank"
                    data-id="financialServicesGuideLink"
                    rel="noopener noreferrer"
                >
                    Financial Service Guide
                </a>
                {' and '}
                {renderPromoTAndCLink()}
                <a
                    href="https://secure.comparethemarket.com.au/static/legal/privacy_collection_notice_car.pdf"
                    target="_blank"
                    data-id="websitePrivacyPolicyFormTermsLink"
                    rel="noopener noreferrer"
                >
                    Privacy Collection Notice,
                </a>
                {' including that Compare the Market may email and SMS me about the services it provides.'}
            </>
        );
    };
    const checkedActions = [
        {
            type: 'SET_FORM_VALUE',
            identifier: 'applicant.optInEmail',
            value: 'Y',
            stateKey: 'vertical.quote'
        }
    ];
    const uncheckedActions = [
        {
            type: 'SET_FORM_VALUE',
            identifier: 'applicant.optInEmail',
            value: 'N',
            stateKey: 'vertical.quote'
        }
    ];
    const schema = {
        stateKey: 'vertical.quote',
        field: {
            type: 'checkbox',
            UIComponent: 'checkbox_medium_rounded',
            labelEl: renderLabel(),
            variant: 'small_text',
            default: '',
            value: 'Y'
        },
        identifier: 'applicant.optInEmail',
        eventProps: {
            onChange: {
                checked: {
                    actions: checkedActions
                },
                unchecked: {
                    actions: uncheckedActions
                }
            }
        }
    };

    return (
        <>
            <Checkbox
                schema={schema}
                value={value}
                dispatch={dispatch}
                key={schema.identifier}
            />
        </>
    );
};

_OptinEmail.propTypes = {
    dispatch: PropTypes.func.isRequired,
    stateProps: PropTypes.shape({
        isOpen: PropTypes.bool
    }),
    value: PropTypes.string,
    isToyPromoOn: PropTypes.bool,
    isToyPromoOff: PropTypes.bool
};

_OptinEmail.defaultProps = {
    value: 'N'
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    const value = form.getIn(['applicant', 'optInEmail']);
    const experimentId = experimentIdSelector(state);

    // CAR_TOY_PROMO_YES and CAR_TOY_PROMO_NO are different A/B testing trigger values
    const isToyPromoOn = experimentId === 'CAR_TOY_PROMO_YES';
    const isToyPromoOff = experimentId === 'CAR_TOY_PROMO_NO';

    return {
        value,
        isToyPromoOn,
        isToyPromoOff
    };
};

const OptinEmail = withRules(connect(mapStateToProps)(_OptinEmail));

export { _OptinEmail, OptinEmail };
